import { loadRobotsConfig } from "./_actions";
import { RobotsEditor } from "./_editor";

export const dynamic = "force-dynamic";

const SITE = process.env.NEXT_PUBLIC_SITE_URL ?? "https://v2.finzone.io.vn";

export default async function RobotsAdminPage() {
  const config = await loadRobotsConfig();

  return (
    <div>
      <div className="mb-6">
        <h2 className="font-display font-semibold text-lg mb-1">Robots.txt Editor</h2>
        <p className="text-sm text-ink-muted">
          Cấu hình robots.txt động — chặn AI crawler, set Crawl-delay, custom rules cho
          từng bot. Lưu vào DB, revalidate sau 600s.
        </p>
      </div>

      <RobotsEditor
        initialRules={config.rules}
        initialHost={config.host}
        sitemap={`${SITE}/sitemap.xml`}
      />
    </div>
  );
}
